export const getFullImageUrl = (imageUrl: string): string => {
  return !imageUrl.includes('http') ? `https:${imageUrl}` : imageUrl;
};
